import debug from "debug";
import { wait } from "@evergiving/common/dist/es2015/utils";

const log = debug(__filename);

export interface AblyMessage {
  message: string;
  error: boolean;
}

export async function fetchAblyMessage({
  apiKey,
  channelName,
}: {
  apiKey: string;
  channelName: string;
}): Promise<AblyMessage> {
  const Ably = await import("ably/promises");
  const client = new Ably.Realtime({
    key: apiKey,
  });

  try {
    const channel = client.channels.get(channelName, {
      params: { rewind: String(1) },
      cipher: undefined,
      modes: ["SUBSCRIBE"],
    });

    const messagePromise = new Promise<AblyMessage>((resolve, reject) => {
      channel.subscribe((message) => {
        try {
          const payload = message.data;
          log("Received message from Ably: ", payload);

          resolve(payload as AblyMessage);
        } catch (e) {
          reject(e);
        }
      });
    });

    const timeoutPromise = wait<AblyMessage>(90_000, {
      message: "Timeout Error",
      error: false,
    });

    return await Promise.race([messagePromise, timeoutPromise]);
  } finally {
    client.close();
  }
}
